import { itemsAPI } from '../api/itemsAPI';

const STORAGE_KEY = 'flea_viewer_geo_v1';
const TTL_MS = 24 * 60 * 60 * 1000;

/**
 * Cached approximate coordinates from IP geolocation (server-side ipinfo).
 * Returns { lat, lon } or null. Never prompts for GPS.
 */
export async function getApproximateViewerCoordinates() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const o = JSON.parse(raw);
      if (typeof o.expiresAt === 'number' && Date.now() < o.expiresAt) {
        if (o.lat != null && o.lon != null) {
          return { lat: Number(o.lat), lon: Number(o.lon), source: o.source };
        }
        return null;
      }
    }
  } catch {
    // ignore cache parse errors
  }

  try {
    const data = await itemsAPI.getViewerGeo();
    const lat = data?.latitude;
    const lon = data?.longitude;
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          lat: lat ?? null,
          lon: lon ?? null,
          source: data?.source,
          expiresAt: Date.now() + TTL_MS,
        }),
      );
    } catch {
      // ignore quota errors
    }
    if (lat != null && lon != null) {
      return { lat: Number(lat), lon: Number(lon), source: data?.source };
    }
    return null;
  } catch {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ lat: null, lon: null, expiresAt: Date.now() + TTL_MS }),
      );
    } catch {
      // ignore
    }
    return null;
  }
}
